"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubFormType = void 0;
var SubFormType;
(function (SubFormType) {
    SubFormType["NONE"] = "None";
    SubFormType["POLE"] = "pole";
    SubFormType["SPAN"] = "span";
})(SubFormType || (exports.SubFormType = SubFormType = {}));
//# sourceMappingURL=form.js.map